import { isUrl } from './isUrl';

const YOUTUBE_HOSTNAMES = [
  'youtube.com',
  'www.youtube.com',
  'm.youtube.com',
  'music.youtube.com',
  'youtube-nocookie.com',
  'www.youtube-nocookie.com',
];
const VIDEO_ID_PATH_PREFIXES = ['embed', 'live', 'shorts'];
const NON_VIDEO_EMBED_IDS = ['live_stream', 'videoseries'];
const VIDEO_ID_PATTERN = /^[\w-]{11}$/;

const getVideoIdCandidate = ({ hostname, pathname, searchParams }: URL) => {
  const [firstSegment = '', secondSegment = ''] = pathname.split('/').filter(Boolean);

  if (hostname === 'youtu.be') {
    return firstSegment;
  }

  if (!YOUTUBE_HOSTNAMES.includes(hostname)) {
    return '';
  }

  if (firstSegment === 'watch') {
    return searchParams.get('v') ?? '';
  }

  return VIDEO_ID_PATH_PREFIXES.includes(firstSegment) ? secondSegment : '';
};

export const getYoutubeVideoId = (url?: string) => {
  if (!url || !isUrl(url)) {
    return '';
  }

  const videoId = getVideoIdCandidate(new URL(url));

  if (!VIDEO_ID_PATTERN.test(videoId) || NON_VIDEO_EMBED_IDS.includes(videoId)) {
    return '';
  }

  return videoId;
};
